document.addEventListener('DOMContentLoaded', function() {

      

    setTimeout(() => {

        var loadingSVGIcon = `
        <svg role="status" class="as-inline as-w-20 as-h-8 as-text-gray-200 as-animate-spin as-fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path>
        </svg>
        `;

        $('.as-subscription').each( function(index) {
            var subID = $(this).find('span.as-contract-id').text();
            // Subscription is 16634118450
            // if( subID.includes('16634118450') ) { 
            var isGoldDust = false;
            var isGummiesCherry = false;
            $(this).find('p.as-product-title').each(function(index){
                var productTitle = $(this).text();
                if( productTitle.includes('Gold Dust - Cocoa') || productTitle.includes('Gold Dust - Cacao') || productTitle.includes('Gold Dust - Kakao') ) {
                    isGoldDust = true;
                }
                if( productTitle.includes('Gummies - Cherry') || productTitle.includes('Gummies - Kers') || productTitle.includes('Gominolas - Cereza' ) || productTitle.includes('Gummibärchen - Kirsche') ) {
                    isGummiesCherry = true;
                }
            })

            // Gold Dust and Gummies Cherry Exist so we can gie option of removal of gummies
            if( isGoldDust && isGummiesCherry ) {
                var removeGummies = `<button type="button" class="as-w-full md:as-w-auto md:as-mr-2 as-items-center as-px-2 as-py-1 lg:as-py-2 as-mt-2 as-border as-border-red-600 as-rounded-md as-shadow-sm as-text-sm as-font-medium as-text-red-600 as-bg-transparent hover:as-bg-red-600 hover:as-text-white focus:as-outline-none focus:as-ring-2 focus:as-ring-offset-2 focus:as-ring-red-500  disabled:as-opacity-75 disabled:as-cursor-not-allowed disabled:as-bg-red-600 disabled:as-text-white as-button as-button--removeGummies" data-subID='${subID}'>Remove Gummies</button>`;
                $(this).find('.appstle-contract-cancel-and-detail-wrapper').prepend(removeGummies);
            }
            if( isGoldDust && !isGummiesCherry ) {
                var addGummies = `<button type="button" class="as-w-full as-mt-2 as-w-full md:as-w-auto as-items-center as-px-2 as-py-1 lg:as-py-2 as-border as-border-green-900 as-rounded-md as-shadow-sm as-text-sm as-font-medium as-text-green-900 as-bg-transparent hover:as-bg-green-900 hover:as-text-white focus:as-outline-none focus:as-ring-2 focus:as-ring-offset-2 focus:as-ring-green-700 disabled:as-opacity-75 disabled:as-cursor-not-allowed disabled:as-bg-green-900 disabled:as-text-white as-button  as-button--addGummies" data-subID='${subID}'>Add Gummies</button>`;
                $(this).find('.appstle-contract-cancel-and-detail-wrapper').prepend(addGummies);
            }
            //}
        });
        



        $('body').on('click', '.close-popup_refresh', function() {
            $('.as-modal-add-up-sell-products').remove();
            location.reload();
        });

        $('.as-button--addGummies').on('click', function() {
            var url = __st.pageurl;
            var parts = url.split('/');
            var tokenID = parts[parts.length - 1].replace(/^subscriptions\?token=/, "");
            var subID = $(this).attr('data-subID').replace(/\D/g, '');
            $(this).attr("disabled", "disabled");
            $(this).html(loadingSVGIcon);
            var $this = $(this);
            $.ajax({
                url: `https://www.varietymode.com/apps/subscriptions/cp/api/v2/subscription-contracts-add-line-item?contractId=${subID}&quantity=1&variantId=gid://shopify/ProductVariant/44536725831986&token=${tokenID}`,
                type: 'PUT',
                success: function(response) {
                    $('body').append(htmlContent('Added Gummies - Cherry'));
                    $this.removeAttr("disabled");
                    $this.html("Add Gummies");
                },
                error: function(xhr, status, error) {
                    $('body').append(htmlContent('Add Gummies - Cherry', xhr.responseText));
                    console.error('Error:', error);
                    console.error('Status:', status);
                    console.error('Response:', xhr.responseText);
                }
            });
            
        });


        $('.as-button--removeGummies').on('click', function() {
            var url = __st.pageurl;
            var parts = url.split('/');
            var tokenID = parts[parts.length - 1].replace(/^subscriptions\?token=/, "");
            var subID = $(this).attr('data-subID').replace(/\D/g, '');
            var lineItemID = ''; 
            $(this).attr("disabled", "disabled");
            $(this).html(loadingSVGIcon);
            var $this = $(this);

            $.ajax({
                url: `https://www.varietymode.com/apps/subscriptions/cp/api/subscription-contracts/contract-external/${subID}?isExternal=true&token=${tokenID}`,
                type: 'GET',
                success: function(data) {
                    let edges = data.lines.edges;
                    for (let index = 0; index < edges.length; index++) {
                        const title = edges[index].node.title;
                        if( title.includes('Gummies - Cherry') ) { 
                            lineItemID = edges[index].node.id;

                            $.ajax({
                                url: `https://www.varietymode.com/apps/subscriptions/cp/api/subscription-contracts-remove-line-item?contractId=${subID}&lineId=${lineItemID}&isExternal=true&removeDiscount=false&token=${tokenID}`,
                                type: 'PUT',
                                success: function(response) {
                                    
                                    $('body').append(htmlContent('Deleted Gummies - Cherry'));
                                    $this.removeAttr("disabled");
                                    $this.html("Remove Gummies");
                                },
                                error: function(xhr, status, error) {
                                    $('body').append(htmlContent('Delete Gummies - Cherry', xhr.responseText ));
                                    console.error('Error:', error);
                                    console.error('Status:', status);
                                    console.error('Response:', xhr.responseText);
                                }
                            });

                        }
                    }
                },
                error: function(error) {
                    $('body').append(htmlContent('Delete Gummies - Cherry', error ));
                }
            });
            
        });
    }, 7000);


    function htmlContent(  title, message= 'Success' ) {
        return `<div class="as-modal-add-up-sell-products as-fixed as-inset-0 as-overflow-y-auto appstle-wrapper" id="headlessui-dialog-:r6:" role="dialog" aria-modal="true" data-headlessui-state="open" aria-labelledby="headlessui-dialog-title-:r8:">
            <div class="as-flex as-items-center as-justify-center as-min-h-screen as-pt-4 as-px-4 as-pb-20 as-text-center sm:as-block sm:as-p-0 as-modal-root">
                <div class="as-fixed as-inset-0 as-bg-gray-500 as-bg-opacity-75 as-transition-opacity as-modal-overlay" id="headlessui-dialog-overlay-:r7:" aria-hidden="true" data-headlessui-state="open"></div>
                <span class="as-hidden sm:as-inline-block sm:as-align-middle sm:as-h-screen" aria-hidden="true">&ZeroWidthSpace;</span>
                <div class="as-relative as-inline-block as-align-bottom as-bg-white as-rounded-lg as-text-left as-overflow-hidden as-shadow-xl as-transform as-transition-all sm:as-my-8 sm:as-align-middle sm:as-max-w-xl sm:as-max-h-2xl sm:as-w-full">
                    <div class="as-bg-white ">
                        <div class="as-px-4 as-pt-5 as-pb-4 sm:as-p-6 sm:as-pb-4 as-text-lg as-leading-6 as-font-medium as-text-gray-900 as-border-b as-modal-title as-modal-header " id="headlessui-dialog-title-:r8:" data-headlessui-state="open">
                            <div class="as-flex h-7 as-items-center as-justify-between">
                                <div>${title}</div>
                                <button type="button" class="-as-m-2 as-p-2 as-text-gray-400 hover:as-text-gray-500 close-popup_refresh" id="header-close-button">
                                    <span class="as-sr-only">Close panel</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" class="as-h-6 as-w-6"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path></svg>
                                </button>
                            </div>
                        </div>
                        <div class="as-px-4 as-pt-5 as-pb-4 sm:as-p-6 sm:as-pb-4 as-modal-body  ">
                            <div class="as-flex as-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" class="as-inline as-h-10 as-w-10 as-ml-1 as-stroke-green-500 as-cursor-pointer">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"></path>
                                </svg>
                                <div class="as-text-gray-500 as-text-sm as-ml-4">${message}</div>
                            </div>
                        </div>
                        <div class=" as-border-t as-px-4 as-py-3 sm:as-px-6 as-grid as-gap-2 as-modal-footer as-modal-cta-wrapper">
                            <button type="button" class="as-w-full as-items-center as-px-2 as-py-1 lg:as-px-4 lg:as-py-2 as-border as-border-indigo-600  hover:as-bg-indigo-600 hover:as-text-white as-rounded-md as-shadow-sm as-text-sm as-font-medium as-text-indigo-600 as-bg-white focus:as-outline-none focus:as-ring-2 focus:as-ring-offset-2 focus:as-ring-indigo-500 as-button as-button--secondary as-button_modal-close close-popup_refresh">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
    }
    
});
